/* Market Spas — teinte adaptative des icônes de l'en-tête mobile (11/09/2026).
   Sous 1100 px l'en-tête est une pilule de verre fixe. Ses icônes (menu, panier, recherche) étaient codées en
   sombre par ms-header-glass et disparaissaient sur les sections nuit (page contact, héros produit, saunas).
   Ce script lit ce qui est PEINT derrière la pilule, à gauche (menu) et à droite (panier + recherche), puis pose
   sur <html> les classes ms-hdr-dark-l / ms-hdr-dark-r que ms-header-tone.css exploite.
   Méthode : elementsFromPoint sous la pilule → premier élément hors en-tête → on remonte les ancêtres en
   composant leurs fonds (couleur, dégradé vertical interpolé à la hauteur du point, image = réputée sombre)
   jusqu'à un fond opaque. Un ancêtre data-ms-tone="dark|light" court-circuite le calcul. Hystérésis pour ne
   pas clignoter sur les dégradés. window.msHeaderTone.update() force un recalcul (tests, sections dynamiques). */
(function () {
  'use strict';
  var MQ = '(max-width: 1099px)';
  var root = document.documentElement;
  var CLS = { l: 'ms-hdr-dark-l', r: 'ms-hdr-dark-r' };
  var ON = 0.42, OFF = 0.55;      /* luminance perçue 0..1 : sombre sous ON, clair au-dessus de OFF */
  var IMAGE_LUM = 0.2;            /* fond photo : réputé sombre (héros, ambiances nuit du site) */
  var state = { l: false, r: false };
  var ticking = false;

  function header() { return document.querySelector('.js-header.header'); }

  function parseColor(str) {
    if (!str) return null;
    var m = /rgba?\(([^)]+)\)/.exec(str);
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    if (p.length < 3 || isNaN(p[0]) || isNaN(p[1]) || isNaN(p[2])) return null;
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 && !isNaN(p[3]) ? p[3] : 1 };
  }
  function lum(c) { return (0.299 * c.r + 0.587 * c.g + 0.114 * c.b) / 255; }

  /* premier dégradé d'une valeur background-image, parenthèses équilibrées */
  function firstGradient(image) {
    var i = image.search(/(linear|radial|conic)-gradient\(/);
    if (i < 0) return null;
    var start = image.indexOf('(', i), depth = 0;
    for (var k = start; k < image.length; k++) {
      if (image[k] === '(') depth++;
      else if (image[k] === ')') { depth--; if (depth === 0) return { kind: image.slice(i, start), body: image.slice(start + 1, k) }; }
    }
    return null;
  }

  /* couche { l, a } d'un dégradé au point y : interpolation des arrêts pour un dégradé vertical, moyenne sinon */
  function gradientLayer(g, rect, y) {
    var stops = [], re = /rgba?\([^)]+\)(?:\s+([\d.]+)%)?/g, s;
    while ((s = re.exec(g.body))) { var c = parseColor(s[0]); if (c) stops.push({ l: lum(c), a: c.a, p: s[1] != null ? parseFloat(s[1]) / 100 : null }); }
    if (!stops.length) return null;
    var head = g.body.slice(0, 40);
    var directed = /^\s*(-?[\d.]+(deg|turn|rad|grad)|to\s)/.test(head);
    var vertical = g.kind === 'linear-gradient' && (!directed || /^\s*(180deg|0\.5turn|to bottom)\b/.test(head));
    if (!vertical || !rect || rect.height <= 0) {
      var L = 0, A = 0;
      for (var i = 0; i < stops.length; i++) { L += stops[i].l; A += stops[i].a; }
      return { l: L / stops.length, a: A / stops.length };
    }
    for (var j = 0; j < stops.length; j++) if (stops[j].p == null) stops[j].p = stops.length === 1 ? 0 : j / (stops.length - 1);
    var t = Math.min(1, Math.max(0, (y - rect.top) / rect.height));
    if (t <= stops[0].p) return { l: stops[0].l, a: stops[0].a };
    for (var k = 1; k < stops.length; k++) {
      if (t <= stops[k].p) {
        var a = stops[k - 1], b = stops[k], f = b.p === a.p ? 0 : (t - a.p) / (b.p - a.p);
        return { l: a.l + (b.l - a.l) * f, a: a.a + (b.a - a.a) * f };
      }
    }
    var last = stops[stops.length - 1];
    return { l: last.l, a: last.a };
  }

  /* couche peinte par un élément : { l, a } ou null s'il ne peint rien */
  function layerOf(node, y) {
    var tone = node.getAttribute && node.getAttribute('data-ms-tone');
    if (tone === 'dark') return { l: 0, a: 1 };
    if (tone === 'light') return { l: 1, a: 1 };
    var cs = getComputedStyle(node);
    if (cs.visibility === 'hidden' || cs.display === 'none') return null;
    var op = parseFloat(cs.opacity); if (isNaN(op)) op = 1;
    if (op === 0) return null;
    var layer = null, img = cs.backgroundImage;
    if (img && img !== 'none') {
      var g = firstGradient(img);
      if (g) layer = gradientLayer(g, node.getBoundingClientRect(), y);
      else if (img.indexOf('url(') !== -1) layer = { l: IMAGE_LUM, a: 1 };
    }
    var bc = parseColor(cs.backgroundColor);
    if (bc && bc.a > 0) {
      var under = { l: lum(bc), a: bc.a };
      layer = layer ? { l: layer.l * layer.a + under.l * (1 - layer.a) * under.a, a: layer.a + (1 - layer.a) * under.a } : under;
      if (layer.a > 0) layer.l = layer.l / layer.a;
    }
    if (!layer || layer.a <= 0) return null;
    return { l: layer.l, a: layer.a * op };
  }

  function bodyLum() {
    var b = parseColor(getComputedStyle(document.body).backgroundColor);
    if (b && b.a >= 0.5) return lum(b);
    var h = parseColor(getComputedStyle(root).backgroundColor);
    if (h && h.a >= 0.5) return lum(h);
    return 0.94; /* fond ivoire par défaut du thème */
  }

  /* luminance composée de ce qui est peint au point (x, y), en ignorant l'en-tête et ses voisins fixes */
  function sample(x, y) {
    var h = header();
    var stack = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
    var acc = 0, accA = 0;
    function add(layer) { acc += (1 - accA) * layer.a * layer.l; accA += (1 - accA) * layer.a; }
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (!el || el === root || el === document.body) continue;
      if (h && (el === h || h.contains(el))) continue;
      if (el.closest && el.closest('.ms-progress, .ms-mobile-buy-bar, #shopify-section-header, .shopify-section-group-header-group')) continue;
      var node = el;
      while (node && node !== root && node !== document.body && accA < 0.95) {
        var layer = layerOf(node, y);
        if (layer) add(layer);
        node = node.parentElement;
      }
      break;
    }
    if (accA < 0.95) add({ l: bodyLum(), a: 1 });
    return accA > 0 ? acc / accA : 1;
  }

  function decide(side, l) {
    var cur = state[side];
    var next = cur ? !(l > OFF) : (l < ON);
    if (next !== cur) { state[side] = next; root.classList.toggle(CLS[side], next); }
  }

  function update() {
    ticking = false;
    var h = header();
    if (!h || !(window.matchMedia && window.matchMedia(MQ).matches)) {
      if (state.l || state.r) { state.l = state.r = false; root.classList.remove(CLS.l, CLS.r); }
      return;
    }
    var r = h.getBoundingClientRect();
    if (!r.height) return;
    var y = r.top + r.height / 2;
    decide('l', sample(r.left + 30, y));
    decide('r', (sample(r.right - 30, y) + sample(r.right - 74, y)) / 2);
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(update); else setTimeout(update, 16);
  }

  window.msHeaderTone = { update: update, sample: sample };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('load', function () { update(); setTimeout(update, 400); setTimeout(update, 1500); });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();
